module.exports = __webpack_public_path__ + "static/img/p2.5a9ffa27.png";